class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    if (facetForm) facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      /* 2026-08-16 — CHỈ NHẬN STATE DO CHÍNH MÌNH GHI.
       *
       * Trên trang danh mục có HAI nơi cùng ghi lịch sử:
       *   · assets/collection-oos-sort.js:353 → history.pushState({ page: N }, …)
       *   · updateURLHash ở dưới              → history.pushState({ searchParams }, …)
       * Dòng cũ chỉ hỏi `event.state ? … : …`. Gặp state {page:2} thì `event.state`
       * là truthy nên nó lấy `.searchParams` = undefined, so với searchParamsPrev
       * ('' trên URL sạch) thấy khác nhau, rồi renderPage(undefined) ghép ra URL
       * đuôi `&undefined`. ĐO THẬT:
       *   GET /collections/vietnamese?section_id=…&undefined → HTTP 200, 24 thẻ,
       *   sản phẩm đầu = three-crabs-brand-fish-sauce-24-oz — đúng y TRANG 1.
       * Máy chủ bỏ qua tham số rác và trả trang 1; renderProductGridContainer đè
       * nguyên #ProductGridContainer (thanh phân trang nằm trong đó), và cú fetch
       * này về SAU cú renderPage() đồng bộ của oos-sort nên nó là kẻ ghi cuối ⇒
       * khách bấm Back thấy lưới nhảy về trang 1 trong khi URL và thanh phân trang
       * vẫn ghi trang 2.
       * State không có khoá `searchParams` là của người khác — bỏ qua, để oos-sort
       * tự xử (nó có popstate riêng ở :361). */
      if (event.state && !Object.prototype.hasOwnProperty.call(event.state, 'searchParams')) return;
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      if (typeof searchParams !== 'string') return; // không bao giờ ghép '&undefined' vào URL
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  /* SKELETON — 2026-08-16 (Phase 6 "cảm giác nhanh").
   *
   * Trước đây đổi bộ lọc là phủ một MẢNG TRẮNG (`.loading-overlay`) lên lưới
   * cho tới khi máy chủ trả về. Khách không biết đang chờ cái gì.
   *
   * Nay dựng khung xương ĐÚNG SỐ THẺ ĐANG HIỆN, nên chiều cao lưới không đổi
   * (CLS = 0) và chỗ cuộn của khách giữ nguyên. Không đoán một con số cố định:
   * lưới 4 thẻ mà dựng 12 khung là tự tay làm trang dài gấp ba rồi co lại.
   *
   * Không có lưới / không có thẻ nào (đang ở trạng thái 0 kết quả) thì thôi,
   * để mảng trắng cũ lo — dựng khung xương từ hư không sẽ làm trang dài ra.
   */
  /* 🔴 17/8 vòng 16 — `#product-grid` KHÔNG PHẢI LÚC NÀO CŨNG LÀ DANH SÁCH THẺ.
   * Trên trang danh mục thì đúng: `<ul id="product-grid" class="… product-grid">`
   * chứa 24 thẻ `<li>`. Nhưng trên /search cái id đó nằm trên DIV BỌC CẢ KHU
   * KẾT QUẢ (main-search.liquid:105, :127) — con duy nhất của nó là
   * `<div class="row">` gồm cột bộ lọc, cột kết quả và thanh phân trang.
   * Hậu quả: n = 1 ⇒ dựng ĐÚNG MỘT khung xương `<div class="row">` thay cho
   * TOÀN BỘ khu kết quả. Khách tick một bộ lọc trên /search là cột lọc, drawer
   * "Filter & sort" và thanh phân trang biến mất sạch, trang co lại rồi bung
   * ra khi máy chủ trả về. restoreSkeleton() cứu được lúc hỏng, nhưng cú giật
   * thì luôn xảy ra.
   * Nay tìm đúng danh sách thẻ, và nếu chỉ có 1 con thì THÔI — một con gần như
   * chắc chắn nghĩa là đang nhìn nhầm vào thẻ bọc, mà dựng nhầm còn tệ hơn
   * không dựng. */
  /* 🔴 15/9/2026 (vòng 49) — Ở TRẠNG THÁI 0 KẾT QUẢ, KHUNG XƯƠNG NUỐT LUÔN
   * ĐƯỜNG THOÁT CỦA KHÁCH.
   *
   * Vòng 16 đã chặn ca "nhìn nhầm vào thẻ bọc" bằng ngưỡng `n < 2`, nhưng vế
   * `|| host` ở dòng cuối vẫn trả về cái thẻ bọc khi không tìm thấy danh sách
   * thẻ nào — và nhánh 0 kết quả của
   * sections/main-collection-product-grid.liquid:141 render
   * `<div class="collection collection--empty" id="product-grid">` với ĐÚNG HAI
   * con: `.loading-overlay.gradient` và `.title-wrapper.center` (bên trong là
   * "No products found" + link "clear all"). n = 2 ⇒ lọt qua ngưỡng ⇒
   * showSkeleton chép `tagName/className` của con đầu ra 2 khung
   * `<div class="loading-overlay gradient aef-skel">` rồi `grid.innerHTML = html`
   * quét sạch hộp thông báo. Khách vừa lọc ra 0 kết quả, tick thêm một ô nữa,
   * thì trong 0,3-1s chờ máy chủ đúng cái link "clear all" — đường thoát duy
   * nhất — biến mất khỏi màn hình.
   *
   * Chú thích vòng 16 ngay trên đã nói đúng ý định rồi ("nhìn nhầm vào thẻ bọc
   * thì THÔI"), chỉ là `|| host` phá nó. Bỏ vế đó: không có danh sách thẻ thì
   * KHÔNG CÓ LƯỚI, trả `null` để renderPage rơi về mảng trắng cũ — mảng trắng
   * phủ LÊN chứ không xoá, nên hộp "No products found" vẫn đọc được.
   *
   * 🪤 ĐỪNG chữa bằng cách nâng ngưỡng `n < 3`: con số 2 là đặc điểm của ĐÚNG
   * nhánh rỗng hôm nay, thêm một `<div>` vào section là bug quay lại. Và nâng
   * ngưỡng thì lưới THẬT có đúng 2 thẻ cũng mất khung xương.
   * 🪤 ĐỪNG chữa bằng `classList.contains('collection--empty')`: /search dựng
   * hộp rỗng ở tầng sâu hơn (main-search.liquid:405), lớp đó không nằm trên
   * `#product-grid` nên luật sẽ trượt ở một nửa số trang. */
  static khungLuoi() {
    const host = document.getElementById('product-grid');
    if (!host) return null;
    if (host.classList.contains('product-grid')) return host;
    return host.querySelector('.product-grid');
  }

  static showSkeleton() {
    const grid = FacetFiltersForm.khungLuoi();
    if (!grid) return false;
    const cards = grid.children;
    const n = cards.length;
    if (n < 2) return false;
    /* 🔴 23/8/2026 (vòng 25) — HAI LƯỢT LỌC CHỒNG NHAU LÀM ẢNH CHỤP TỰ HỎNG.
       Khách bấm lọc lần 2 khi phản hồi lần 1 chưa về ⇒ showSkeleton() chạy lần
       nữa và chụp đè lên CHÍNH KHUNG XƯƠNG. Đo bằng jsdom với chính file này:
         lượt 1: ảnh chụp có "SP 1" = true
         lượt 2: ảnh chụp có "SP 1" = FALSE, có "aef-skel" = TRUE
         restoreSkeleton(true): còn 3 khung xương · 0 sản phẩm thật
       Tức đường lùi trả về đúng cái LƯỚI XƯƠNG VĨNH VIỄN mà nó sinh ra để chặn,
       và câu báo lỗi thì tự xoá sau 6 giây — khách ở lại với một lưới rỗng câm.
       Đã có ảnh chụp THẬT rồi thì GIỮ NGUYÊN, đừng chụp đè.
       Trả `true` chứ không `false`: renderPage:158 dùng giá trị này để bật cờ
       `has-skeleton`; trả false là bật lại mảng trắng đè lên khung xương đang hiện. */
    if (grid.querySelector('.aef-skel')) return true;
    FacetFiltersForm.gridEl = grid;
    /* CHỤP LẠI LƯỚI THẬT TRƯỚC KHI ĐÈ.
     * Khung xương thay HẲN nội dung lưới, nên nếu lượt fetch hỏng (mất mạng,
     * máy chủ 500) thì khách ở lại với một lưới xương VĨNH VIỄN, không sản
     * phẩm và không một lời giải thích. Mảng trắng cũ ít nhất còn để lộ hàng
     * nằm dưới. Có ảnh chụp thì restoreSkeleton() trả lại được nguyên trạng. */
    FacetFiltersForm.gridSnapshot = grid.innerHTML;
    // giữ nguyên thẻ bọc (li/div) của lưới để lớp CSS grid không đổi cách xếp
    const tag = cards[0].tagName.toLowerCase();
    const cls = cards[0].className;
    let html = '';
    for (let i = 0; i < n; i++) {
      html += '<' + tag + ' class="' + cls + ' aef-skel" aria-hidden="true">'
        + '<div class="aef-skel__box"></div>'
        + '<div class="aef-skel__line"></div>'
        + '<div class="aef-skel__line aef-skel__line--short"></div>'
        + '<div class="aef-skel__line aef-skel__line--price"></div>'
        + '<div class="aef-skel__line aef-skel__line--btn"></div>'
        + '</' + tag + '>';
    }
    grid.innerHTML = html;
    return true;
  }

  /* Trả lưới về đúng như trước khi dựng khung xương, và NÓI cho khách biết là
     hỏng. Im lặng ở đây là đúng cái đã vá ở nút "+" hôm 14/8: hiệu ứng chạy,
     kết quả không tới, không ai giải thích. */
  static restoreSkeleton(failed) {
    /* Trả lại ĐÚNG phần tử đã bị đè, không đi tìm lại bằng id: trên /search hai
       thứ đó khác nhau (xem chú thích ở showSkeleton), trả nhầm chỗ là nhét ảnh
       chụp danh sách thẻ vào thẻ bọc. Có ảnh chụp mà không có phần tử thì lùi về
       cách cũ cho an toàn. */
    /* 23/8 — thêm `isConnected`: khi lượt #1 thành công (thay hẳn lưới) mà lượt #2
       rớt, `gridEl` đang trỏ vào một node MỒ CÔI đã rời tài liệu. Ghi ảnh chụp vào
       đó là ghi vào hư không, và câu báo lỗi cũng bị chèn cạnh node mồ côi ⇒ khách
       không thấy lời nào. Rơi vào ca đó thì lùi về khungLuoi() đang sống. */
    let grid = FacetFiltersForm.gridEl || FacetFiltersForm.khungLuoi();
    if (grid && !grid.isConnected) grid = FacetFiltersForm.khungLuoi();
    if (grid && grid.isConnected && FacetFiltersForm.gridSnapshot != null) {
      grid.innerHTML = FacetFiltersForm.gridSnapshot;
    }
    FacetFiltersForm.gridSnapshot = null;
    FacetFiltersForm.gridEl = null;
    const container = document.getElementById('ProductGridContainer');
    const coll = container && container.querySelector('.collection');
    if (coll) { coll.classList.remove('loading'); coll.classList.remove('has-skeleton'); }
    ['ProductCount', 'ProductCountDesktop'].forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.classList.remove('loading');
    });
    if (!failed) return;
    const t = (window.aefT && window.aefT('facets.err_load')) || "Couldn't load — please try again";
    let box = document.getElementById('aef-facet-err');
    if (!box) {
      box = document.createElement('p');
      box.id = 'aef-facet-err';
      box.setAttribute('role', 'status');
      box.style.cssText = 'margin:12px 0;padding:10px 14px;border-radius:8px;background:#fdecea;color:#a3261a;font-weight:600';
      /* 15/9/2026 (vòng 49) — NEO DỰ PHÒNG. Từ cú vá khungLuoi ở trên, ở trạng
         thái 0 kết quả hàm đó trả `null` (đúng: không có danh sách thẻ nào),
         nên `grid` ở đây có thể rỗng. Trước khi có dòng dưới, `box` được dựng
         ra rồi KHÔNG BAO GIỜ được chèn vào tài liệu ⇒ fetch rớt trên trang 0
         kết quả là hỏng CÂM — đúng cái bệnh im lặng mà cả khối chú thích trên
         đầu hàm này sinh ra để chữa. Neo vào chính `#product-grid`. */
      const neo = (grid && grid.isConnected) ? grid : document.getElementById('product-grid');
      if (neo && neo.parentNode) neo.parentNode.insertBefore(box, neo);
    }
    box.textContent = '⚠️ ' + t;
    setTimeout(function () { if (box && box.parentNode) box.parentNode.removeChild(box); }, 6000);
    // thẻ vừa trả lại là HTML cũ — cầu i18n/stepper phải chạy lại trên chúng
    try { document.dispatchEvent(new CustomEvent('aef:cards-injected', { detail: { sectionId: 'facets-restore' } })); } catch (e) {}
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    /* 🔴 25/9/2026 (vòng 53) — LƯỢT CŨ VỀ SAU ĐÈ LƯỢT MỚI.
     *
     * Mỗi lần gọi hàm này là bắn một lượt Section Rendering, và updateURLHash ở
     * cuối hàm pushState NGAY LÚC BẮN ⇒ URL luôn là của lượt mới nhất. Nhưng
     * renderSectionFromFetch trước đây vẽ theo thứ tự lượt nào VỀ trước, không
     * theo thứ tự lượt nào ĐƯỢC BẮN trước. Mà renderProductGridContainer thay
     * NGUYÊN #ProductGridContainer (cột lọc 🖥, ngăn lọc 📱, ô sắp xếp, phân trang
     * đều nằm trong đó) ⇒ phản hồi cũ về muộn kéo lùi lưới, dòng đếm, ô tick, ô
     * sắp xếp, dưới một URL đang nói điều ngược lại. Đo trên LIVE
     * /collections/vietnamese (jsdom, phản hồi thật): URL sạch mà khách thấy
     * «214 of 395 products» + ô «In stock» vẫn tick.
     * Ba đường vào không qua debounce 500ms nên hai lượt có thể cách nhau ~0:
     * popstate/Back, gỡ viên lọc / Clear all, và form thứ hai (lọc 🖥 + Sắp xếp có
     * debounce RIÊNG). Đường bộ đệm (renderSectionFromCache) vẽ ĐỒNG BỘ, nên một
     * lượt mạng đang bay về sau còn đè được cả nó — không cần mạng đảo thứ tự.
     *
     * Chữa: đánh SỐ LƯỢT. Chỉ lượt mới nhất được vẽ, và chỉ lượt mới nhất được báo
     * hỏng (lượt cũ rớt mà gọi restoreSkeleton(true) là chép lại ảnh chụp từ trước
     * CẢ HAI lượt lên lưới vừa vẽ đúng, kèm câu «Couldn't load» oan). Lượt cũ về
     * vẫn được ƯỚP vào filterData — lần sau khách quay lại đúng trạng thái đó khỏi
     * chờ mạng.
     * 🪤 KHÔNG dùng AbortController thay số lượt: huỷ là mất phần ướp, và nhánh
     *    catch phải lọc thêm AbortError, không thì mỗi cú huỷ lại hiện câu báo lỗi.
     * 🪤 Đường bộ đệm cũng đi qua ĐÚNG dòng dưới, nên nó cũng vô hiệu mọi lượt đang
     *    bay — đừng tách nó ra khỏi hàm này.
     * Người gác: scripts/test-loc-luot-cu-khong-de-luot-moi.js */
    const luot = ++FacetFiltersForm.luot;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const collectionEl = document.getElementById('ProductGridContainer').querySelector('.collection');
    collectionEl.classList.add('loading');
    // Dựng được khung xương thì tắt mảng trắng đi — hai thứ chồng lên nhau thì
    // mảng trắng che mất chính khung xương vừa dựng.
    collectionEl.classList.toggle('has-skeleton', FacetFiltersForm.showSkeleton());
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event, luot);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  /* `luot` = số lượt renderPage vừa cấp (xem khối vòng 53 ở renderPage). Thiếu thì
     coi là lượt hiện hành — giữ nguyên hành vi cũ cho ai gọi trần. */
  static renderSectionFromFetch(url, event, luot = FacetFiltersForm.luot) {
    fetch(url)
      .then((response) => {
        /* 2026-08-16 — TRƯỚC ĐÂY KHÔNG XÉT response.ok. Máy chủ trả 404/500 thì
           `.text()` vẫn chạy, DOMParser vẫn dựng, và renderProductGridContainer
           lặng lẽ `return` vì trang lỗi không có #ProductGridContainer ⇒ lưới
           đứng nguyên trạng thái đang tải, không một lời nào. */
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        if (luot !== FacetFiltersForm.luot) return;
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      })
      .catch(() => { if (luot !== FacetFiltersForm.luot) return; FacetFiltersForm.restoreSkeleton(true); });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
    const target = document.getElementById('ProductGridContainer');
    if (!parsed || !target) return;
    /* 🔴 4/9/2026 (vòng 40) — TICK MỘT Ô LỌC TRÊN 📱 LÀ TRANG KHOÁ CUỘN VĨNH VIỄN.
     *
     * Ngăn «Lọc và sắp xếp» của điện thoại là `<menu-drawer data-breakpoint="mobile">`
     * (snippets/facets.liquid:306) và nó nằm BÊN TRONG chính #ProductGridContainer mà
     * dòng ngay dưới sắp đè (sections/main-collection-product-grid.liquid:60 → :91-93;
     * sections/main-search.liquid:166 → :242 cũng vậy). Khách mở ngăn đó thì
     * MenuDrawer.openMenuDrawer (assets/global.js:470) gắn `overflow-hidden-mobile`
     * lên <body>. Tick một ô lọc ⇒ dòng dưới xoá luôn cái drawer ĐANG MỞ khỏi DOM ⇒
     * không còn ai đi qua closeMenuDrawer ⇒ lớp nằm lại trên <body> vĩnh viễn.
     * Đo bằng bánh xe ở 390×844: trước khi mở ngăn lọc cuộn được 700 px, sau khi tick
     * còn 0 px — mà trên màn hình KHÔNG còn hộp thoại nào để khách hiểu vì sao trang
     * đứng im. Đây là đường duyệt danh mục trên điện thoại, kênh chính.
     *
     * 🪤 BẪY 1 — ĐỌC MÃ. Khối `.overflow-hidden-mobile` ở assets/base.css:1434 ĐANG
     * BỊ CHÚ THÍCH CHẾT. Grep đúng file đó rồi kết luận "luật khoá cuộn đã tắt, bug
     * vô hại" là kết luận NGƯỢC: commit 7961ada (20/8) đã viết lại luật ấy ở
     * assets/component-facets.css:293-295 trong @media (max-width:767px), không chú
     * thích, đang chạy, và cả hai section trên đều nạp file đó.
     *
     * 🪤 BẪY 2 — MỘT NGUỒN. Lớp ấy do MenuDrawer SỞ HỮU (nó đọc data-breakpoint để
     * ghép tên lớp). Ở đây chỉ gọi đúng ĐƯỜNG ĐÓNG của nó, KHÔNG tự tay
     * `document.body.classList.remove('overflow-hidden-mobile')` — tự gỡ là đẻ
     * người-ghi-thứ-hai cho cùng một trạng thái VÀ chép cứng tên breakpoint sang chỗ
     * thứ hai. Đúng khuôn bug «Mua 3 chỉ $0.00» của giỏ (JS tự phán lại điều kiện mà
     * máy chủ đã quyết).
     *
     * 🪤 BẪY 3 — GỌI TRẦN LÀ NO-OP. `closeMenuDrawer(event, …)` ở global.js:475 chỉ
     * làm gì đó khi `event !== undefined`. Viết `d.closeMenuDrawer()` thì mã trông y
     * hệt bản vá này mà bug quay lại nguyên vẹn, không một lời báo.
     *
     * 🪤 BẪY 4 — CHỈ ĐÓNG CÁI ĐANG MỞ. closeMenuDrawer gọi removeTrapFocus(), thứ này
     * gỡ handler TOÀN CỤC; gọi vô cớ lên một drawer đang đóng là cướp bẫy tiêu điểm
     * của hộp thoại khác. Hỏi đúng `mainDetailsToggle` — chính thuộc tính MenuDrawer
     * dùng — thay vì tự đoán bằng selector riêng.
     *
     * Người gác: scripts/test-loc-mobile-khong-khoa-cuon.js (đo bằng BÁNH XE, vì
     * window.scrollTo vẫn cuộn được một viewport overflow:hidden ⇒ đo bằng nó là
     * xanh cả ba ca). */
    /* 🔴 vòng 48, 14/9/2026 — TICK MỘT Ô LỌC TRÊN 📱 LÀ NGĂN «Lọc và sắp xếp» ĐÓNG SẬP.
     *
     * Cùng một gốc bệnh với khối vòng 40 ở trên (drawer 📱 nằm TRONG chính
     * #ProductGridContainer sắp bị đè), nhưng là cái giá còn lại sau khi vòng 40 đã
     * cứu phần khoá cuộn: ngăn lọc bị xoá khỏi DOM, và HTML máy chủ trả về luôn render
     * `<details class="mobile-facets__disclosure disclosure-has-popup">` KHÔNG có `open`
     * (đã curl LIVE /collections/vietnamese bằng UA iPhone: 0 thuộc tính `open` trên
     * details 📱, trong khi bản 🖥 `Details-1/2` có `open=""` cứng ⇒ chỉ 📱 chịu trận).
     * Form 📱 tự nộp sau debounce 500ms (dòng 6-11) nên chỉ cần tick một ô, dừng đọc
     * vài giây, là ngăn bốc hơi — muốn thêm bộ lọc thứ hai phải chạm «Lọc và sắp xếp»
     * + mở lại mục + cuộn lại (3 thao tác thừa). Đo bằng jsdom trên HTML THẬT của LIVE:
     * trước vá `NGĂN LỌC còn MỞ: false · MỤC CON còn MỞ: false · scrollTop: 0` (đặt 248).
     *
     * 🪤 ĐỪNG GỠ VÒNG LẶP ĐÓNG DRAWER Ở DƯỚI để "chữa" — nó không phải thủ phạm
     * (`innerHTML` xoá node dù có gọi hay không), gỡ là dựng lại nguyên bug KHOÁ CUỘN
     * VĨNH VIỄN của vòng 40.
     *
     * 🪤 MỘT NGUỒN (BẪY 2 ở trên vẫn nguyên giá trị). Ở đây KHÔNG tự tay
     * `classList.add('overflow-hidden-mobile')`. Lớp đó do MenuDrawer sở hữu, nên mở
     * lại đi đúng `drawer.openMenuDrawer(summary)` (global.js:493) — chính nó ghép tên
     * lớp từ `data-breakpoint`. Thứ tự bắt buộc: ĐÓNG (gỡ lớp) → thay ruột → MỞ (gắn
     * lại). Đảo thứ tự là khoá cuộn vĩnh viễn quay lại y như vòng 40.
     *
     * 🪤 MỤC CON PHẢI NHỚ RIÊNG. Trả lại cái vỏ thôi là chưa đủ: `.mobile-facets__details`
     * cũng render không `open`, và CSS component-facets.css:499
     * `.js details[open].menu-opening > .mobile-facets__submenu` đòi CẢ HAI thứ mới hiện
     * ruột. Nhánh mở mục con của global.js (onSummaryClick:486-491) không có hàm công
     * khai nào gọi lại được, nên chép đúng ba dòng nó làm: `open` + `menu-opening` +
     * `aria-expanded`.
     *
     * Chỉ mở lại cái ĐANG MỞ, đọc bằng chính `mainDetailsToggle` của MenuDrawer — khách
     * 🖥 đổi sắp xếp thì không có drawer nào mở ⇒ không cướp tiêu điểm của ai. */
    const nganDangMo = [];
    target.querySelectorAll('menu-drawer').forEach((drawer, i) => {
      if (typeof drawer.closeMenuDrawer !== 'function') return;   // custom element chưa nâng cấp
      const mo = drawer.mainDetailsToggle;
      if (!mo || !mo.hasAttribute('open')) return;                // đang đóng thì không đụng vào
      const trong = mo.querySelector('.mobile-facets__inner');
      nganDangMo.push({
        i: i,
        mucCon: Array.from(mo.querySelectorAll('details[open][data-index]')).map((el) => el.dataset.index),
        cuon: trong ? trong.scrollTop : 0
      });
      drawer.closeMenuDrawer(new Event('aef:truoc-khi-thay-luoi'));
    });
    target.innerHTML = parsed.innerHTML;
    /* Khung xương biến mất cùng lượt thay HTML này. Gỡ cờ để lần sau `.loading`
       lại được quyết lại từ đầu — quên gỡ thì mảng trắng dự phòng vĩnh viễn bị
       tắt, kể cả những lần không dựng được khung xương. */
    const coll = target.querySelector('.collection');
    if (coll) coll.classList.remove('has-skeleton');
    /* 2026-08-16 — BÁO CHO CẦU i18n + STEPPER.
     * Lưới vừa thay là HTML MỚI TINH từ máy chủ, tức tiếng Anh. Trước dòng này,
     * khách đang xem tiếng Việt chỉ cần đổi thứ tự sắp xếp hoặc tick một bộ lọc là
     * cả lưới nạp lại bằng tiếng Anh và NẰM LUÔN tiếng Anh tới khi tải lại trang.
     * ae-delivery-widget.js:1253 nghe 'aef:cards-injected' để dịch lại, và
     * card-stepper.js:436 nghe cùng sự kiện để dựng lại số lượng theo giỏ cho thẻ
     * mới. Đúng một sự kiện, hai người nghe có sẵn — không đẻ thêm người ghi.
     * Cùng khuôn với bản vá `efa75ac` cho đường /cart. */
    try { document.dispatchEvent(new CustomEvent('aef:cards-injected', { detail: { sectionId: 'facets' } })); } catch (e) {}
    /* vòng 48, 14/9/2026 — MỞ LẠI ngăn lọc 📱 vừa bị `target.innerHTML` ở trên nuốt.
     *
     * Ba lý do khối này nằm ĐÚNG ở đây chứ không ngay dưới dòng thay ruột:
     *   · phải chạy SAU vòng lặp đóng drawer (dòng ~303) để `overflow-hidden-mobile`
     *     đi trọn một vòng gỡ→gắn của MenuDrawer — đảo thứ tự là khoá cuộn vĩnh viễn
     *     của vòng 40 quay lại;
     *   · phải chạy SAU cú bắn 'aef:cards-injected' ở dòng trên, vì người gác
     *     scripts/test-doi-ruot-phai-dich-lai.js (TAM = 12 dòng) đòi lệnh chép ruột và
     *     lời gọi dịch lại nằm trong CÙNG một nhịp — chen 25 dòng vào giữa là nó đỏ;
     *   · chỗ cuộn trả lại sau khi bộ dịch đã chạy thì mới là chỗ cuộn khách thấy.
     * Cả ba đều đồng ý một chỗ, nên để nguyên. */
    if (nganDangMo.length) {
      const nganMoi = target.querySelectorAll('menu-drawer');
      nganDangMo.forEach((tt) => {
        const drawer = nganMoi[tt.i];
        if (!drawer || typeof drawer.openMenuDrawer !== 'function') return;
        const mo = drawer.mainDetailsToggle;
        const sum = mo && mo.querySelector('summary');
        if (!mo || !sum) return;
        mo.setAttribute('open', '');
        drawer.openMenuDrawer(sum);
        tt.mucCon.forEach((idx) => {
          const con = mo.querySelector(`details[data-index="${idx}"]`);
          if (!con) return;
          con.setAttribute('open', '');
          con.classList.add('menu-opening');
          const s = con.querySelector('summary');
          if (s) s.setAttribute('aria-expanded', 'true');
        });
        const trong = mo.querySelector('.mobile-facets__inner');
        if (trong && tt.cuon) trong.scrollTop = tt.cuon;
      });
    }
  }

  /* 2026-08-16 — CHỐNG NULL. Cả ba lệnh dưới đây trước đây đều giả định phản hồi
   * LUÔN có #ProductCount và trang hiện tại LUÔN còn #ProductCount. Cả hai giả
   * định đều gãy khi bộ lọc ra 0 kết quả. Nhánh rỗng của hai section đã được sửa
   * để luôn render facets, nhưng vẫn chặn ở đây: một section mới, một app chèn
   * markup, hay Shopify đổi cách trả về đều có thể làm gãy lại — và khi gãy thì
   * nó ném lỗi giữa chuỗi render, kéo chết cả những bước phía sau. */
  static renderProductCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    if (!parsed) return;
    const count = parsed.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    /* 24/8/2026 — chép ruột từ máy chủ thì phải dịch lại. Đám viên lọc đang
       bật ở đây mang data-i18n từ commit bf05d90; không dịch lại là khách bấm
       một bộ lọc xong thấy chúng lật về tiếng Anh. renderProductGridContainer
       (dòng ~228) đã bắn 'aef:cards-injected' cho phần lưới, nhưng vùng này
       nằm NGOÀI lưới nên không được hưởng. */
    if (window.applyTranslations) { try { window.applyTranslations(); } catch (e) {} }

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    /* 24/8/2026 — `.mobile-facets__open` chính là nút "Lọc và sắp xếp" mà khách
       📱 phải chạm để lọc bất cứ thứ gì, và `.sorting` là ô chọn sắp xếp. Cả hai
       mới được gắn data-i18n ở commit bf05d90. Chép ruột mà không dịch lại thì
       chúng lật về tiếng Anh ngay sau cú lọc đầu tiên — đúng cái nút quan trọng
       nhất trên trang danh mục điện thoại. */
    if (window.applyTranslations) { try { window.applyTranslations(); } catch (e) {} }

    /* Dòng này hỏi trên TÀI LIỆU HIỆN TẠI chứ không phải trên `html` vừa tải về.
     * Khi lọc ra 0 kết quả, renderProductGridContainer đã xoá sạch cột lọc (mobile
     * drawer nằm bên trong #ProductGridContainer) ⇒ null.closest ném lỗi. Và vì
     * renderAdditionalElements chạy TRƯỚC renderProductGridContainer trong chuỗi
     * popstate, lỗi này còn giết luôn cú Back của trình duyệt. */
    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    const drawer = mobileForm && mobileForm.closest ? mobileForm.closest('menu-drawer') : null;
    if (drawer && typeof drawer.bindEvents === 'function') drawer.bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  /* 2026-08-16 — GỘP THAM SỐ THEO QUYỀN SỞ HỮU.
   *
   * Trước đây dòng này là `new URLSearchParams(new FormData(form))`, tức URL mới
   * chỉ gồm các ô của ĐÚNG form vừa chạm, rồi updateURLHash pushState đè nguyên
   * query cũ. Mà trang danh mục có HAI form riêng biệt:
   *   · form bộ lọc  (snippets/facets.liquid:28, .facets__form) → chỉ có filter.*
   *   · form sắp xếp (snippets/sorting.liquid:28)               → chỉ có sort_by
   * Nên khách đặt khoảng giá $0–10 rồi đổi "Sắp xếp" là bộ lọc bay sạch, và ngược
   * lại. Đo trên HTML staging: form lọc không hề có ô name="sort_by".
   *
   * Cách gộp — theo QUYỀN SỞ HỮU chứ không theo "có thì lấy":
   *   · q + options[prefix]: luôn giữ từ URL (trang tìm kiếm mất là hỏng hẳn).
   *   · sort_by: form sắp xếp sở hữu; form khác chạm thì giữ nguyên giá trị cũ.
   *   · filter.*: form lọc sở hữu TOÀN BỘ — lấy hết từ FormData của nó, kể cả khi
   *     rỗng (bỏ tick hết = phải xoá hết). Form khác chạm thì bê nguyên từ URL.
   * Nhận diện bằng DANH TÍNH form, không bằng nội dung: nếu dò "form này có khoá
   * filter.* không" thì lúc khách bỏ tick cái cuối cùng, form rỗng sẽ bị hiểu là
   * "không sở hữu" và bộ lọc cũ bị khôi phục lại — không bao giờ xoá được.
   * `page` luôn bị bỏ: đổi lọc/sắp xếp thì phải về trang 1. */
  onSubmitHandler(event) {
    event.preventDefault();
    const form = event.target.closest('form');
    const formData = new FormData(form);
    const current = new URLSearchParams(window.location.search);
    const ownsFilters = form.classList.contains('facets__form')
      || form.classList.contains('mobile-facets')
      || form.id === 'FacetFiltersFormMobile';

    const next = new URLSearchParams();
    /* 5/9/2026 — `qq` và `aef_raw` PHẢI đi cùng `q`, nếu không bộ dịch câu hỏi
     * (assets/aef-search-rewrite.js) hỏng theo hai cách khác nhau:
     *   · rơi `qq`      ⇒ mất chữ GỐC của khách, ô tìm kiếm phơi cú pháp máy ra
     *     màn hình, và thang lui hết đường về (nó lấy chữ gốc từ đúng `qq`).
     *   · rơi `aef_raw` ⇒ trang ĐÃ LUI về câu trần, khách đổi cách sắp xếp một
     *     cái là cờ bay mất, bộ dịch tưởng câu chưa dịch nên dịch lại, ra rỗng,
     *     rồi không lui được nữa vì `qq` cũng đã rơi ⇒ khách KẸT ở trang trắng.
     * Ba khoá này là một bộ, đừng tách. */
    ['q', 'options[prefix]', 'qq', 'aef_raw'].forEach((k) => { if (current.has(k)) next.set(k, current.get(k)); });

    /* 🔴 18/8/2026 — `type` PHẢI được mang theo, nếu không bản vá Họ ② là vô nghĩa.
     *
     * Hàm này dựng URL mới từ một DANH SÁCH TRẮNG. Ô ẩn `type=product` vừa gắn vào
     * hai form lọc (snippets/facets.liquid) đi qua FormData — mà FormData không nằm
     * trong danh sách trắng ⇒ `type` bị VỨT ở đúng đường khách thật đi: mở drawer
     * "Filter and sort", đổi sắp xếp hoặc tick một bộ lọc.
     *
     * Đo thật trên staging, cùng một section id:
     *     ?q=pho&type=product&sort_by=price-ascending → 361 kết quả, 24 thẻ
     *     ?q=pho&sort_by=price-ascending              → 364 kết quả, 22 thẻ
     * Tức là vừa bấm sắp xếp một cái là con số lại nói dối như cũ, và lưới hụt 2 ô.
     *
     * Lấy từ URL trước (giống hệt cách `q` đang làm — để form sắp xếp không "sở hữu"
     * nó), CHƯA có trên URL thì mới lấy từ chính form. Vế sau là thứ làm cho ô ẩn
     * trong facets.liquid có tác dụng thật: khách vào bằng một link cũ không có
     * `type`, bấm bộ lọc phát đầu là URL tự đúng lại.
     *
     * Trang danh mục không bao giờ có `type` ⇒ cả hai vế đều rỗng ⇒ không đổi gì. */
    if (current.has('type')) next.set('type', current.get('type'));
    else if (formData.get('type')) next.set('type', formData.get('type'));

    if (formData.has('sort_by')) {
      const v = formData.get('sort_by');
      if (v) next.set('sort_by', v);
    } else if (current.has('sort_by')) {
      next.set('sort_by', current.get('sort_by'));
    }

    const src = ownsFilters ? formData : current;
    for (const [k, v] of src.entries()) {
      if (k.indexOf('filter.') !== 0) continue;
      if (v === '' || v == null) continue;
      next.append(k, v);
    }

    FacetFiltersForm.renderPage(next.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    /* 01/11/2026: `value.url_to_remove` do Shopify dựng, không biết `qq` và `aef_raw`. Gỡ một viên
     * lọc trên trang đã lui về câu trần là mất cờ, bộ dịch dịch lại rồi kẹt trang trắng, đúng ca
     * onSubmitHandler đã ghi ở trên. Trang danh mục không có hai khoá này nên url giữ nguyên từng ký tự. */
    const hienTai = new URLSearchParams(window.location.search);
    const dich = new URLSearchParams(url);
    const thieu = ['qq', 'aef_raw'].filter((k) => hienTai.has(k) && !dich.has(k));
    thieu.forEach((k) => dich.set(k, hienTai.get(k)));
    FacetFiltersForm.renderPage(thieu.length ? dich.toString() : url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.luot = 0;   // số lượt renderPage đã bắn — xem khối vòng 53 ở renderPage
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (!minInput || !maxInput) return;
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const link = this.querySelector('a');
    if (!link) return;
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);
